var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPlayButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#322C3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1601 38.0801L30.9401 26.4701C30.6268 26.325 30.2822 26.2605 29.9377 26.2825C29.5932 26.3046 29.2596 26.4125 28.9674 26.5963C28.6752 26.7802 28.4337 27.0342 28.2647 27.3353C28.0957 27.6364 28.0048 27.9749 28.0001 28.3201V51.5301C27.9971 51.8845 28.0857 52.2336 28.2571 52.5437C28.4286 52.8539 28.6771 53.1145 28.9787 53.3005C29.2804 53.4865 29.6249 53.5916 29.979 53.6055C30.3331 53.6195 30.6848 53.5418 31.0001 53.3801L54.1601 41.7701C54.5031 41.5979 54.7916 41.3337 54.9931 41.007C55.1947 40.6803 55.3014 40.304 55.3014 39.9201C55.3014 39.5362 55.1947 39.1599 54.9931 38.8332C54.7916 38.5065 54.5031 38.2423 54.1601 38.0701V38.0801Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayButton);
export default __webpack_public_path__ + "static/media/video-play-button.b95b13c06dc7ebac581319a58ef2da6f.svg";
export { ForwardRef as ReactComponent };